import React, { useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Common from "../../component/Common.js";
import { get } from "../../lib/comm.js";
import {
  MainContext,
  STATUS_ONLINE,
  UIContext,
  UpdateContext,
} from "../../main-context.js";
import Spinner from "../helpers/Spinner.js";
import offline_css from "../offline.module.css";

export default function Fueler() {
  const update_context = useContext(UpdateContext);
  const main_context = useContext(MainContext);
  const history = useHistory();
  useEffect(() => {
    async function call_api() {
      const fuelers = await get(
        "/api/home",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (fuelers === "comm error") return;

      const flash_audit_status = await get(
        "/api/flash-audit/status",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (flash_audit_status === "comm error") return;

      const fso_status = await get(
        "/api/inspections/fso/status",
        null,
        main_context.status.id,
        update_context,
        history
      );
      if (fso_status === "comm error") return;

      update_context.update_main_context((prev) => ({
        ...prev,
        fso_status: {
          pending: fso_status.pending,
          equipmentId: fso_status.equipmentId,
        },
        fuelers: {
          pointsToday: fuelers.pointsToday,
          outOfServiceCount: fuelers.outOfServiceCount,
          inspectionsRemaining: fuelers.inspectionsRemaining,
          isfuelfarm: fuelers.isfuelfarm,
        },
        flash_audit_status: {
          active_flash_audits: flash_audit_status.activeFlashAudits,
          pending_items: flash_audit_status.pendingItems,
        },
      }));
    }
    call_api();
  }, [history, main_context.status.id, update_context]);
  return (
    <UIContext.Consumer>
      {({ online_status }) => (
        <MainContext.Consumer>
          {({ fuelers, flash_audit_status, fso_status }) => (
            <div>
              <Common></Common>
              <div
                className={"home-commands " + offline_css["fueler-min-width"]}
              >
                <div className="row">
                  <div className="col-xs-12">
                    <p>
                      {!!flash_audit_status.active_flash_audits && (
                        <Link
                          to={update_context.settings.subfolder + "/fa/index"}
                          className="btn btn-danger btn-block"
                        >
                          Active Flash Audits:
                          <strong>
                            {flash_audit_status.active_flash_audits}
                          </strong>
                          <br />
                          Pending Items:
                          <strong>{flash_audit_status.pending_items}</strong>
                        </Link>
                      )}
                    </p>
                    <p>
                      {fso_status.pending && (
                        <Link
                          to={
                            update_context.settings.subfolder +
                            "/fso/preview/" +
                            fso_status.equipmentId
                          }
                          className="btn btn-danger btn-block"
                        >
                          FSO Pending
                        </Link>
                      )}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 col-sm-6">
                    <p>
                      <Link
                        to={
                          update_context.settings.subfolder +
                          "/inspections/daily"
                        }
                        className="btn btn-block btn-default btn-lg"
                      >
                        Daily Inspections
                      </Link>
                    </p>
                  </div>
                  <div className="col-xs-12 col-sm-6">
                    <p>
                      <Link
                        to={
                          update_context.settings.subfolder +
                          "/inspections/weekly"
                        }
                        className="btn btn-block btn-default btn-lg"
                      >
                        Weekly Inspections
                      </Link>
                    </p>
                  </div>
                  <div className="col-xs-12 col-sm-6">
                    <p>
                      {(online_status === STATUS_ONLINE && (
                        <Link
                          to={
                            update_context.settings.subfolder +
                            "/online-only/users/leaderboard"
                          }
                          className="btn btn-block btn-default btn-lg"
                        >
                          Leaderboard
                        </Link>
                      )) || (
                        <span
                          className="btn btn-block btn-default btn-lg"
                          style={{
                            backgroundColor: "#eaeaea",
                          }}
                        >
                          Leaderboard
                        </span>
                      )}
                    </p>
                  </div>

                  {fuelers && fuelers.isfuelfarm && (
                    <div className="col-xs-12 col-sm-6">
                      <p>
                        {(online_status === STATUS_ONLINE && (
                          <Link
                            to={
                              update_context.settings.subfolder +
                              "/online-only/inventory"
                            }
                            className="btn btn-block btn-default btn-lg"
                          >
                            Inventory
                          </Link>
                        )) || (
                          <span
                            className="btn btn-block btn-default btn-lg"
                            style={{
                              backgroundColor: "#eaeaea",
                            }}
                          >
                            Inventory
                          </span>
                        )}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="row text-center">
                <div className="col-xs-12 col-sm-6">
                  <h3>Equipment Inspections Remaining</h3>
                  <h2>
                    <strong>
                      <Spinner
                        waitfor={
                          fuelers && fuelers.inspectionsRemaining != null
                        }
                        className="spin-loader"
                      >
                        {fuelers ? fuelers.inspectionsRemaining : ""}
                      </Spinner>
                    </strong>
                  </h2>
                </div>
                <div className="col-xs-12 col-sm-6">
                  <h3>Out of Service Equipment</h3>
                  <h2>
                    <strong>
                      {" "}
                      <Spinner
                        waitfor={fuelers && fuelers.outOfServiceCount != null}
                        className="spin-loader"
                      >
                        {fuelers ? fuelers.outOfServiceCount : ""}
                      </Spinner>
                    </strong>
                  </h2>
                </div>
                {/* <div className="col-xs-12 col-sm-4">
                  <h3>Points Awarded Today</h3>
                  <h2>
                    <strong>
                      {" "}
                      <Spinner
                        waitfor={fuelers && fuelers.pointsToday != null}
                        className="spin-loader"
                      >
                        {fuelers ? fuelers.pointsToday : ""}
                      </Spinner>
                    </strong>
                  </h2>
                </div> */}
              </div>
            </div>
          )}
        </MainContext.Consumer>
      )}
    </UIContext.Consumer>
  );
}
